var $93aa1d77b41feeb5$exports = {};
$93aa1d77b41feeb5$exports = {
    "info": `Informazioni`,
    "negative": `Errore`,
    "notice": `Avvertenza`,
    "positive": `Operazione riuscita`
};


export {$93aa1d77b41feeb5$exports as default};
//# sourceMappingURL=it-IT.mjs.map
